// frontend/src/utils/marketTimeChecker.js

const INDIAN_TIMEZONE = 'Asia/Kolkata';

// Equity/F&O Hours
const EQUITY_START_HOUR = 9;
const EQUITY_START_MINUTE = 15;
const EQUITY_END_HOUR = 15;
const EQUITY_END_MINUTE = 30;

// Hardcoded holidays for 2026
const INDIAN_HOLIDAYS = [
  '2026-01-26', // Republic Day
  '2026-03-26', // Holi
  '2026-04-14', // Ambedkar Jayanti
  '2026-05-01', // Maharashtra Day
  '2026-08-15', // Independence Day
  '2026-10-02', // Gandhi Jayanti
  '2026-11-08', // Diwali
  '2026-12-25', // Christmas
];

const getISTComponents = () => {
    const now = new Date();
    const options = {
        hour: 'numeric',
        minute: 'numeric',
        weekday: 'long',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour12: false,
        timeZone: INDIAN_TIMEZONE
    };
    const istString = now.toLocaleString('en-US', options);
    const istDate = new Date(istString);
    
    return {
        hour: istDate.getHours(),
        minute: istDate.getMinutes(),
        day: istDate.getDay(),
        dateStr: istDate.toISOString().slice(0, 10)
    };
};

export const isMarketOpen = (type = 'equity') => {
    const { hour, minute, day, dateStr } = getISTComponents();

    // Check for holidays
    if (INDIAN_HOLIDAYS.includes(dateStr)) {
        return { isOpen: false, message: 'Market is closed due to a holiday.' };
    }

    // Check for weekends
    if (day === 0 || day === 6) {
        return { isOpen: false, message: 'Market is closed on weekends.' };
    }

    let startTotal = 0;
    let endTotal = 0;
    const currentTotal = hour * 60 + minute;

    // Default to Equity/F&O (NSE/BSE/NFO/BFO)
    startTotal = EQUITY_START_HOUR * 60 + EQUITY_START_MINUTE;
    endTotal = EQUITY_END_HOUR * 60 + EQUITY_END_MINUTE;

    if (currentTotal >= startTotal && currentTotal <= endTotal) {
        return { isOpen: true, message: 'Market is open.' };
    } else {
        return { isOpen: false, message: `Equity/F&O market is currently closed.` };
    }
};

// Keep for compatibility but it's limited
export const isIndianMarketOpenFrontend = () => isMarketOpen('equity');
